var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategoriesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M21.0044 18.0025H14.4727",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M21.0044 15.0012H14.4727",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M18.8275 21.0037H14.4727",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M10.8364 17.0751L7.37898 18.8758C7.01918 19.0658 6.58282 19.0353 6.25288 18.7973C5.92295 18.5592 5.7565 18.1547 5.82333 17.7534L6.59965 13.2895L3.32429 10.1262C3.03166 9.84348 2.92619 9.41849 3.05268 9.03177C3.17917 8.64506 3.51541 8.36454 3.91853 8.30942L8.43742 7.65815L10.4563 3.59045C10.6388 3.22622 11.0113 2.99622 11.4187 2.99622C11.8261 2.99622 12.1986 3.22622 12.3811 3.59045L14.4029 7.65815L18.9218 8.30842C19.3245 8.36384 19.6602 8.64416 19.7867 9.03048C19.9131 9.4168 19.808 9.8414 19.516 10.1242L17.6703 11.9089",
    stroke: "#1D2023",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoriesIcon);
export default __webpack_public_path__ + "static/media/categories-icon.3841b9bbfabf8422baa4e5d54af96d0d.svg";
export { ForwardRef as ReactComponent };